import React from 'react';
import { useParams } from 'react-router-dom';
import { SubPanelTratos } from '../features/client';

const PublicClientForm = () => {
    const { uuid } = useParams();

    // Render SubPanelTratos centered with a dark background
    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            backgroundColor: '#0d0d0d',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            {/* Override absolute/fixed positioning from .op-sub-panel-tratos by passing inline styles or wrapping */}
            <div style={{
                width: '100%',
                maxWidth: '540px',
                height: '100%',
                maxHeight: '90vh',
                position: 'relative',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
                right: 'auto',
                top: 'auto',
                bottom: 'auto'
            }} className="public-form-wrapper">
                <SubPanelTratos 
                    publicUuid={uuid} 
                    node={{label: "Formulario", sub: "form"}} 
                    onClose={() => {}} // No-op
                />
            </div>

            <style>{`
                .public-form-wrapper .op-sub-panel-tratos {
                    position: absolute !important;
                    top: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    left: 0 !important;
                    width: 100% !important;
                    border-radius: 12px;
                    border: 1px solid rgba(255,255,255,0.08);
                }
                .public-form-wrapper .op-sub-panel-close {
                    display: none;
                }
            `}</style>
        </div>
    );
};

export default PublicClientForm;
